import { UntypedFormGroup } from '@angular/forms';

export class FieldMatchValidator {
  static compareFields(fieldKey1: string, fieldKey2: string, errorMessage: string) {
    return (group: UntypedFormGroup): { [key: string]: any; } => {
      const field1 = group.controls[fieldKey1];
      const field2 = group.controls[fieldKey2];

      if (field1.value !== field2.value && (field1 !== null || field2 != null)) {
        let oldErrors1 = field1.errors;
        if (oldErrors1 == null) {
          oldErrors1 = {};
        }

        oldErrors1['passwordMatch'] = errorMessage;
        field1.setErrors(oldErrors1);

        return { notValid: true };
      }
      if (field1.hasError('passwordMatch')) {
        let oldPassword = field1.errors;
        delete oldPassword['passwordMatch'];

        if (Object.keys(oldPassword).length === 0) {
          oldPassword = null;
        }
        field1.setErrors(oldPassword);
      }

      return null;
    };
  }
}
